import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
} from "@angular/common/http";
import { tap } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app";
import { TimerOn } from "src/app/store/actions/timer";

@Injectable()
export class ServerTimeInterceptor implements HttpInterceptor {
  constructor(private _store: Store<IAppState>) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): any {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this._store.dispatch(
            new TimerOn({ serverTime: +event.headers.get("server_timestamp") }),
          );
        }
        // სერვერის დროს ვსეტავ სთორში
        // action dispatch
        return event;
      }),
    );
  }
}
